import { cn } from '@/lib/shadcn/lib/utils';

export function Telegram({ className }: { className?: string }) {
  return (
    <svg
      className={cn('size-full', className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9852 15.4083L15.2272 19.0943C16.4272 20.4593 17.0282 21.1423 17.6572 20.9753C18.2852 20.8093 18.5012 19.9113 18.9322 18.1143L21.3222 8.14628C21.9872 5.37828 22.3192 3.99528 21.5812 3.31228C20.8432 2.62928 19.5642 3.13728 17.0062 4.15228L5.14023 8.86528C3.09423 9.67828 2.07123 10.0843 2.00623 10.7823C1.99857 10.8534 1.99857 10.9252 2.00623 10.9963C2.06923 11.6953 3.09023 12.1043 5.13423 12.9233C6.05923 13.2943 6.52223 13.4803 6.85423 13.8353C6.89156 13.8753 6.92756 13.9166 6.96223 13.9593C7.26823 14.3393 7.39823 14.8393 7.65923 15.8353L8.14823 17.7023C8.40123 18.6723 8.52823 19.1583 8.86123 19.2243C9.19423 19.2903 9.48323 18.8883 10.0622 18.0833L11.9852 15.4083ZM11.9852 15.4083L11.6682 15.0783C11.3062 14.7003 11.1252 14.5123 11.1252 14.2783C11.1252 14.0443 11.3052 13.8553 11.6682 13.4783L15.2412 9.75428"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
